/**
 * NOTE: Yup is deprecated in favor of Zod.
 * This file is to remove circular dependencies in the codebase and will be removed in the future.
 * Please use Zod instead.
 */

import * as yup from 'yup';

const baseSlugSchema = yup.string().trim().min(0).max(2048);

export const slug = baseSlugSchema.matches(/^[a-z\d]([a-z\d_-]*[a-z\d])*$/, {
  excludeEmptyString: true,
  message:
    'Slug must start with a letter or digit and may only contain lowercase letters, digits, hyphens, and underscores.',
});

export const slugPath = baseSlugSchema.matches(/^[a-z\d]+[a-z\d_-]*(\/[a-z\d_-]*[a-z\d])*$/, {
  excludeEmptyString: true,
  message:
    'Slug must start with a letter or digit and may only contain lowercase letters, digits, hyphens, underscores, and forward slash.',
});

export const yupCustom = {
  slug: slug,
  slugPath: slugPath,
};
